import { useEffect } from 'react';
import { useLazyGetMerchantMessagesQuery } from 'containers/app/api';
import { selectCurrentTeam, selectIsOwner, selectMerchantMessages } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';
import {
  KycLimitMessagingCase,
  mapKycLimitMessagingContent,
  resolveKycLimitMessagingCase
} from 'utils/kycLimitMessaging';

export const useKycLimitRevisionMessaging = () => {
  const currentTeam = useAppSelector(selectCurrentTeam);
  const isOwner = useAppSelector(selectIsOwner);
  const merchantMessages = useAppSelector(selectMerchantMessages);
  const [getMerchantMessagesQuery] = useLazyGetMerchantMessagesQuery();

  const isRiskReviewPending = currentTeam?.isRiskReviewDone === false;
  const hasMerchantMessages = Object.keys(merchantMessages).length > 0;

  useEffect(() => {
    if (!isRiskReviewPending || hasMerchantMessages) {
      return;
    }

    getMerchantMessagesQuery();
  }, [isRiskReviewPending, hasMerchantMessages, getMerchantMessagesQuery]);

  const messagingCase = isRiskReviewPending ? resolveKycLimitMessagingCase(currentTeam) : KycLimitMessagingCase.NONE;
  const content = isRiskReviewPending ? mapKycLimitMessagingContent(messagingCase, merchantMessages, isOwner) : null;

  return {
    messagingCase,
    content,
    isOwner,
    shouldShow: isRiskReviewPending && messagingCase !== KycLimitMessagingCase.NONE && Boolean(content)
  };
};
